import React, { useEffect, useState } from 'react';
import PageHeader from '../../shared/page-header/PageHeader';
import HandoverItemsModal from './HandoverItemsModal';
import HandoverItemsGrid from './HandoverItemsGrid';
import SKAlerts, { CreateAlert } from '../../shared/common-alerts/SKAlerts';
import axios from 'axios';
import { getStorageValues } from '../../shared/CommonFunctions';
import { getApiBaseUrl } from '../../utils/apiConfig';
import { getModulePermissions } from '../../utils/permissionHelper';
import { exportToExcel, exportToPDF } from '../../utils/downloadExportedFiles';
import { logAuditEvent } from '../../utils/auditLogger';

function HandoverItemsMain(props) {
    const [getHandoverItemsList, setHandoverItemsList] = useState([]);
    const [modalIsOpen, setIsOpen] = React.useState(false);
    const [alert, setAlert] = useState(null);
    const [getUserModulePermission, setUserModulePermission] = React.useState([]);
    const moduleName = props.Module || 'Handover Items';

    useEffect(() => {
        const modulePermissions = getModulePermissions(props.Module);
        setUserModulePermission(modulePermissions ? modulePermissions : []);
        fetchHandoverItems();
    }, [props.Module]);

    useEffect(() => {
        logAuditEvent(moduleName, 'Accessed Module', 'Accessed Handover Items');
    }, [moduleName]);

    function openAddModal() {
        setIsOpen(true);
        logAuditEvent(moduleName, 'Add Button Click', 'Opened add handover items modal');
    }

    function closeModal() {
        setIsOpen(false);
    }

    async function onSubmit(e, data) {
        if (e.target.name === 'Add') {
            const handoverItemsModel = data;
            if (handoverItemsModel) {
                let handoverItemDetails = {
                    HandoverItemId: null,
                    HandoverItemType: handoverItemsModel.HandoverItemType ? handoverItemsModel.HandoverItemType : '',
                    HandoverItemTitle: handoverItemsModel.HandoverItemTitle ? handoverItemsModel.HandoverItemTitle : '',
                    Description: handoverItemsModel.Description ? handoverItemsModel.Description : '',
                    UserId: getStorageValues('userId')
                };
                if (validation(handoverItemDetails)) {
                    try {
                        const response = await axios.post(
                            getApiBaseUrl() + '/handoveritems/save',
                            handoverItemDetails
                        );
                        if (response.status === 200) {
                            if (response.data.data[0].success === 1) {
                                CreateAlert(response.data.data[0].message, 'Success', setAlert);
                                fetchHandoverItems();
                                closeModal();
                            } else {
                                CreateAlert(response.data.data[0].message, 'Error', setAlert);
                            }
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }
            } else {
                CreateAlert('Fields marked with an asterisk (*) are required!!', 'Error', setAlert);
            }
        }
    }

    function validation(handoverItemDetails) {
        let validation = true;
        if (handoverItemDetails) {
            if (!handoverItemDetails.HandoverItemType || handoverItemDetails.HandoverItemType.length === 0) {
                CreateAlert('Please select handover item type!!', 'Warning', setAlert);
                validation = false;
                return;
            }
            if (!handoverItemDetails.HandoverItemTitle || handoverItemDetails.HandoverItemTitle.length === 0) {
                CreateAlert('Please enter handover item title!!', 'Warning', setAlert);
                validation = false;
                return;
            }
        } else {
            CreateAlert('Some proplem fatching user details entered by the user!!', 'Error', setAlert);
            validation = false;
            return;
        }
        return validation;
    }

    const fetchHandoverItems = async () => {
        try {
            let handoverItemDetails = {
                UserId: getStorageValues('userId')
            };
            const response = await axios.get(getApiBaseUrl() + '/handoveritems/getAll', { params: handoverItemDetails });
            if (response.status === 200) {
                setHandoverItemsList(response.data.data[0]);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleExportExcel = () => {
        const columns = [
            { name: 'Handover Item Type', selector: 'HandoverItemType' },
            { name: 'Handover Item Title', selector: 'HandoverItemTitle' },
            { name: 'Description', selector: 'Description' }
        ];
        exportToExcel('HandoverItems', columns, getHandoverItemsList);
    };

    const handleExportPDF = () => {
        const columns = [
            { name: 'Handover Item Type', selector: 'HandoverItemType' },
            { name: 'Handover Item Title', selector: 'HandoverItemTitle' },
            { name: 'Description', selector: 'Description' }
        ];
        exportToPDF('HandoverItems', columns, getHandoverItemsList);
    };

    return (
        <>
            <SKAlerts alert={alert} />
            <PageHeader
                displayModule={props.Module}
                onModelOpen={openAddModal}
                onRefresh={fetchHandoverItems}
                showPDF={true}
                showExcel={true}
                showPrint={false}
                showRefresh={true}
                onExcelExport={handleExportExcel}
                onPdfExport={handleExportPDF}
                showAddButton={getUserModulePermission.AddModule === 1 ? true : false}
            />
            <HandoverItemsGrid HandoverItemsData={getHandoverItemsList} fetchHandoverItems={fetchHandoverItems} UserPermissions={getUserModulePermission} moduleName={moduleName} />
            <HandoverItemsModal
                show={modalIsOpen}
                UserAction={'Add'}
                onClose={closeModal}
                onSubmit={onSubmit}
                moduleName={moduleName}
            />
        </>
    );
}

export default HandoverItemsMain;
